// Where a resolution proposal's proof-of-fix can live.
//
// A submission carries its screenshots in up to three places and which
// one is populated depends on the CHANNEL:
//   evidence[]                     built server-side (buildEvidence) from
//                                  named attachments + every hosted shot
//                                  mirrored into Document Control - but
//                                  mirrorResolutionEvidence silently drops
//                                  any url that is not locally hosted
//   screenshotUrls[]               what the web resolve dialog sends
//   resolvedElements[].screenshotUrl  what the Revit / Navisworks plugin
//                                  sends (it uploads once and stamps the
//                                  url on every selected element, leaving
//                                  screenshotUrls EMPTY)
//
// Reading only one of them hid plugin evidence from reviewers, and an
// `evidence.length ? evidence : screenshotUrls` fallback hid the
// non-mirrored half of a mixed submission. Union them, deduped by url,
// preserving evidence[] entries first (they carry name / kind /
// docControlId).
export function proposalEvidenceItems(proposal) {
  const p = proposal || {};
  const out = [];
  const seen = new Set();
  const push = (item) => {
    const url = item && item.url;
    if (!url || seen.has(url)) return;
    seen.add(url);
    out.push(item);
  };
  for (const e of p.evidence || []) push(e);
  for (const u of p.screenshotUrls || []) push({ url: u, kind: "image" });
  for (const e of p.resolvedElements || []) {
    if (e && e.screenshotUrl) push({ url: e.screenshotUrl, kind: "image", name: "Element screenshot" });
  }
  return out;
}

// True when the submission carries nothing a reviewer could look at.
export function proposalHasEvidence(proposal) {
  return proposalEvidenceItems(proposal).length > 0;
}
